import thunk from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit'
import { objectsReducer, loginReducer } from './reducers'

const reducer = { "objectsReducer": objectsReducer, "loginReducer":loginReducer }

const preloadedState = {}

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== 'production' ?
    { actionSanitizer: (action) => action, stateSanitizer: (state) => state.loginReducer }
    : false,
  preloadedState,
  enhancers: [],
})


export default store;